import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-ds-banner',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './ds-banner.component.html',
    // styleUrl: './ds-banner.component.scss'
})
export class DsBannerComponent {}
